import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SpinnerService } from 'merlin-library';
import { DtvHelperService } from '../../../projects/clinician/src/app/patient-list/direct-trend-viewer/services/dtv-helper.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
    private requests: HttpRequest<any>[] = [];
    public value: boolean = true;
    constructor(public spinnerSer: SpinnerService,
                private dtvService: DtvHelperService
    ) {
        this.dtvService.spinnerBool$.subscribe(val => {
            this.value = val;
        });
    }

    removeRequest(req: HttpRequest<any>) {
        const i = this.requests.indexOf(req);
        if (i >= 0) {
            this.requests.splice(i, 1);
        }
        // Wrap in setTimeout to avoid ExpressionChangedAfterItHasBeenCheckedError
        setTimeout(() => {
            if (this.value === false) {
                this.spinnerSer.visibility = this.value;
            } else {
                this.spinnerSer.visibility = this.requests.length > 0;
            }
        }, 0);
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        this.requests.push(req);
        // Wrap in setTimeout to avoid ExpressionChangedAfterItHasBeenCheckedError
        setTimeout(() => {
            this.spinnerSer.visibility = this.value;
        }, 0);

        return new Observable(observer => {
            const subscription = next.handle(req)
                .subscribe(
                    event => {
                        if (event instanceof HttpResponse) {
                            this.removeRequest(req);
                        }
                        observer.next(event);
                    },
                    err => {
                        this.removeRequest(req);
                        observer.error(err);
                    },
                    () => {
                        this.removeRequest(req);
                        observer.complete();
                    });
            // remove request from queue when cancelled
            return () => {
                this.removeRequest(req);
                subscription.unsubscribe();
            };
        });
    }
}
